import styled from "styled-components";

export const SearchIntailSection = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  padding-left: 10px;
  padding-right: 10px;
`;
